module.exports = __webpack_public_path__ + "static/success-through-stillness-f761402c45ea583c2ccc9e5eeafe3ace.jpg";